// extracted by css-extract-rspack-plugin
export default {"quote":"i13x_I3awJLmI0yT","bar":"FtRXG2gUn44eRVF2","title":"rpnpP5h2ipwcRT9h"};